import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/vercel/path0/node_modules/flowbite-react/dist/esm/components/Accordion/Accordion.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContent"] */ "/vercel/path0/node_modules/flowbite-react/dist/esm/components/Accordion/AccordionContent.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionPanel"] */ "/vercel/path0/node_modules/flowbite-react/dist/esm/components/Accordion/AccordionPanel.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionTitle"] */ "/vercel/path0/node_modules/flowbite-react/dist/esm/components/Accordion/AccordionTitle.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(adelaide)/piano-lessons-adelaide/images/1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(adelaide)/piano-lessons-adelaide/images/2.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(adelaide)/piano-lessons-adelaide/images/3.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(adelaide)/piano-lessons-adelaide/images/4.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(adelaide)/piano-lessons-adelaide/images/5.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroPriceLine"] */ "/vercel/path0/src/components/HeroPriceLine.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileStickyCTA"] */ "/vercel/path0/src/components/MobileStickyCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/MusiCalPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenFaqOnHash"] */ "/vercel/path0/src/components/OpenFaqOnHash.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ServiceAreas.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/testimonials/GoogleReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewMarquee"] */ "/vercel/path0/src/components/testimonials/ReviewMarquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackFaqOpens"] */ "/vercel/path0/src/components/TrackFaqOpens.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/TrialUrgency.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/bethandniv-circle.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/carbon-removal.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/credibility/Adelaide Examiner.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/credibility/state-brand.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/credibility/stripe-climate-member.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/customer-avatars/amyjane.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/customer-avatars/leah.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/customer-avatars/nicola.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/great_company/Australian Piano Warehouse.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/great_company/Erebus Reactor.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/great_company/Eternal Arts Collective.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/great_company/Global Music Revolution.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/great_company/Muso World.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/great_company/Sounds Of Adelaide.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/green-squiggly-arrow.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/instruments/no-instrument-no-probem.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/scale-new-heights-banner.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/support_local/SA Brand.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/support_local/Stripe Climate Member.jpg");
